import { useDispatch, useSelector } from 'react-redux';
import PendingTaskHeader from "../../components/pending-task-header/PendingTaskHeader";
import PendingTaskTile from '../../components/pending-task-tile/PendingTaskTile';
import SubjectApi from '../../services/subjectService';
import { setSnackbar } from '../../store/reducers/snackBar';
import { useEffect, useState } from 'react';
import { PendingTasks } from '../../utils/formik/initialValues';
import EditorApi from '../../services/editorManagementService';
import { CustomSnackbar } from '../../components/snackbar/CustomSnackbar';

const PendingTask = () => {
  const dispatch = useDispatch();
  const role_id = useSelector((state) => state.loginData.role_id);
  const snackbar = useSelector((state) => state.snackBar);
  const [taskCount, setTaskCount] = useState({})
  const [search, setSearch] = useState('')
  const [isClosed, setIsClosed] = useState(false)
  const [openFilter, setOpenFilter] = useState(false)
  const [taskData, setTaskData] = useState([])
  const [requestData, setRequestData] = useState([]);
  const [phaseData, setPhaseData] = useState([])
  const [productData, setProductData] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false)
  const [maxPages, setMaxPages] = useState(null);
  const [alignment, setAlignment] = useState(`Pending tasks`)
  const [filters, setFilters] = useState({});

  const handleFilterSubmit = (p, v) => {
    if (!p) p = {};

    let sendOptionalParameter = {};
    Object.keys(p).forEach((key) => {
      if (p[key] !== null && p[key] !== undefined && p[key] !== '') {
        sendOptionalParameter[key] = p[key];
      }
    });
    if (v?.from) sendOptionalParameter.startDate = v.from;
    if (v?.to) sendOptionalParameter.endDate = v.to;
    setFilters(sendOptionalParameter);
    if (Object.keys(sendOptionalParameter).length > 0) {
      handleGetHistoryData('', sendOptionalParameter);
    }
    setPage(1);
  };


  const handlePhaseSearch = (value) => {
    setSearch(value)
  };

  const handleCloseFilter = () => {
    setOpenFilter(false)
  }

  const handleGetHistoryData = async (status = '', optionalfilter) => {
    setLoading(true);
    setIsClosed(status === '1');
  
    const payload = {
      page: page,
      limit: 10,
    };
  
    const filter = {
      filter: {
        status: status || (alignment.includes('Pending') ? '0' : '1'),
        search: search || '',
        ...optionalfilter
      }
    };
  
    try {
      const response = await SubjectApi.requestHistory(
        payload.limit,
        payload.page,
        payload.phase_id,
        payload.subject_id,
        filter
      );
  
      if (response?.stats) {
        setTaskCount(response);
      } else {
        setTaskCount({});
      }
  
      if (response?.data?.length) {
        setTaskData(prev => page > 1 ? [...prev, ...response.data] : response.data);
      } else {
        // Clear data only when on first page and no results
        if (page === 1) setTaskData([]);
      }
  
      if (response?.page_details) {
        setMaxPages(Math.ceil(response.page_details.no_of_records / response.page_details.limit));
      }
    } catch (error) {
      dispatch(setSnackbar({
        value: true,
        message: error?.message || error || "Failed to fetch data",
        color: "error",
      }));
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };
  
  const handleExportPendingTask = async () => {
    try {
      const res = await SubjectApi.exportRequestList();
      if (!res.data.length) {
        dispatch(setSnackbar({ value: true, message: res?.message, color: "error" }));
      } else {
        const blob = new Blob([res], { type: 'text/plain' });
        const fileURL = URL.createObjectURL(blob);
        const downloadLink = document.createElement('a');
        downloadLink.href = fileURL;
        downloadLink.download = 'request_reason.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        URL.revokeObjectURL(fileURL);
      }
    } catch (error) {
      dispatch(setSnackbar({ value: true, message: error, color: "error" }));
    }
  }

  const handlePendingFilter = () => {
    getAllPhaseDropDown()
    setOpenFilter(true)
  }
  const getStatusDropDown = async () => {
    try {
      const res = await SubjectApi.getAllRequest();
      const result = res.data
        .map((item) => ({
          id: item.id,
          name: item.title,
        }));
      setRequestData(result)
    } catch (error) {
      dispatch(setSnackbar({ value: true, message: error, color: "error" }));
    }
  };

  const getAllPhaseDropDown = async () => {
    try {
      const res = await EditorApi.getPhaseDropDown();
      const result = res.data
        .map((item) => ({
          id: item.id,
          name: `${item.title}${item.product_details?.name ? ` (${item.product_details.name})` : ''}`,
        }));
        const productResult = res.data
        .filter(item => item.product_details)
        .map(item => ({
          id: item.product_details.id,
          name: item.product_details.name,
        }));
      const uniqueProductData = Array.from(
        new Map(productResult.map(item => [item.id, item])).values()
      );
      setProductData(uniqueProductData);
      setPhaseData(result)

    } catch (error) {
      dispatch(setSnackbar({ value: true, message: error, color: "error" }));
    }
  };

  const loadMoreData = () => {
    if (page < maxPages) {
      setPage(prev => prev + 1); 
    }
  };
 
  useEffect(() => {
    if (alignment.includes('Pending')) {
      handleGetHistoryData('0', filters);
    } else {
      handleGetHistoryData('1', filters);
    }
  getStatusDropDown();
  getAllPhaseDropDown();
  setPage(1);
}, [alignment, search, filters]);

  useEffect(() => {
    if (page === 1) return; 
    handleGetHistoryData(alignment.includes('Pending') ? '0' : '1', filters);
  }, [page]);

  return (
    <div>

      <div className='flex flex-col gap-4 mt-4 ml-4 mr-4'>
        <PendingTaskHeader SearchbarPlaceholder="Search by Product/Phase/Patient name"
          width={"100%"}
          handleButtonClick={handlePendingFilter}
          handleSearch={handlePhaseSearch}
          showExportButton={role_id === 1}
          handleExportButton={handleExportPendingTask}
          taskCount={taskCount}
          openFilter={openFilter}
          closeFilter={handleCloseFilter}
          setOpenFilter={setOpenFilter}
          handleFilterSubmit={handleFilterSubmit}
          handleGetHistoryData={handleGetHistoryData}
          setAlignment={setAlignment}
          alignment={alignment}
          requestData={requestData}   // @info For values
          phaseData={phaseData}
          productData={productData}
          initialVal={PendingTasks}
          page={page}
          setPage={setPage}
          setFilters={setFilters}
        />
      </div>
      <div className="px-4 pt-3">
        <PendingTaskTile
          task={taskData}
          isClosed={isClosed}
          loadMoreData={loadMoreData}
          page={page}
          maxPages={maxPages}
          loading={loading}
          alignment={alignment}

        />
      </div>
      <CustomSnackbar
        open={snackbar?.value}
        setOpen={setSnackbar}
        color={snackbar?.color}
        message={snackbar?.message}
      />
    </div>

  );
};

export default PendingTask;
